import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestRequestService } from '@app/restApi/rest-request.service';
import { REST_CONTACT_GROUPS, REST_CONTACTS } from '@app/restApi/RestRoutes';
import {
  Contact,
  ContactGroup,
  ContactGroupCreatePayload,
  ContactPayload,
} from '@app/store/contacts/contacts.types';

@Injectable({
  providedIn: 'root',
})
export class ContactsApiService {
  restService = inject(RestRequestService);

  getContactGroups(): Observable<ContactGroup[]> {
    return this.restService.getWithObservable(REST_CONTACT_GROUPS);
  }

  createContactGroup(data: ContactGroupCreatePayload): Observable<ContactGroup> {
    return this.restService.postWithObservable(REST_CONTACT_GROUPS, data);
  }

  updateContactGroup(id: number, data: ContactGroupCreatePayload) {
    return this.restService.putWithObservable(`${REST_CONTACT_GROUPS}/${id}`, data);
  }

  deleteContactGroup(id: number): Observable<string> {
    return this.restService.delWithObservable(`${REST_CONTACT_GROUPS}/${id}`);
  }

  createContact(data: ContactPayload): Observable<Contact> {
    return this.restService.postWithObservable(REST_CONTACTS, data);
  }

  updateContact(id: number, data: ContactPayload): Observable<Contact> {
    return this.restService.putWithObservable(`${REST_CONTACTS}/${id}`, data);
  }

  deleteContact(id: number): Observable<string> {
    return this.restService.delWithObservable(`${REST_CONTACTS}/${id}`);
  }
}
